import React from 'react';
import { Button } from '../../Buttons';
import { useTrans } from '../../../../services/i18n';
import { Grid } from '@material-ui/core';

function SaveCancelDialogActions({ onCancelClick, onSaveClick, pending = false, color = 'primary', formId = 'form' }) {
  const { trans } = useTrans();
  return (
    <Grid container spacing={2} justifyContent="flex-end">
      <Grid item>
        <Button id={`${formId}-cancel`} variant="outlined" color={color} onClick={onCancelClick} disabled={pending}>
          {trans('cancel')}
        </Button>
      </Grid>
      <Grid item>
        <Button id={`${formId}-save`} variant="contained" color={color} onClick={onSaveClick} pending={pending}>
          {trans('save')}
        </Button>
      </Grid>
    </Grid>
  );
}

export default SaveCancelDialogActions;
